export const environment = {
  production: false,
  stage: 'dev',
  apiUrl: 'https://devapi.redcornerai.com',
  cognitoUserPoolId: 'us-east-2_1tkz9j0BZ',
  cognitoClientId: '2nbq91nlbeprcan7pmqn2jispo',
  cognitoDomain: 'redcornerai-dev-tenant.auth.us-east-2.amazoncognito.com',
  googleClientId: 'PLACEHOLDER_GOOGLE_CLIENT_ID',
  callbackUrl: 'https://dev.redcornerai.com/auth/callback',
  logoutUrl: 'https://dev.redcornerai.com/auth/login',
};
